import React from 'react';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { Card } from 'Components/frameworks/card/Card';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
type Props = {
  config: CMSContent;
  editorialZone:
    | {
        image: string;
        link: string;
        texts: Array<string>;
      }
    | null
    | undefined;
  id?: string;
  seeMore: string;
  title: string;
};
export const ProductFlashInfoLine = ({
  config: {
    common: { close },
  },
  editorialZone,
  id,
  seeMore,
  title,
}: Props) => {
  if (!editorialZone) {
    return null;
  }

  const { image, link, texts } = editorialZone;
  const [headingTitle = '', headingSubtitle = '', text = ''] = texts;
  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <Card
        closeLabel={close}
        ctaLabel={seeMore}
        heading={{
          title: headingTitle,
          subtitle: headingSubtitle,
        }}
        link={{
          url: link,
        }}
        media={{
          alt: headingTitle,
          ratioKey: ratioUtils.XS,
          url: image,
        }}
        text={{
          seeMoreLabel: seeMore,
          text,
        }}
      />
    </SiteContainer>
  );
};
